export default __webpack_public_path__ + "src/assets/icn-check.7fc2df1c9dfb301f7a840ab7d138c4b0.svg";